import { initializeApp } from "firebase/app";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  signInWithRedirect,
  TwitterAuthProvider,
  OAuthProvider
} from "firebase/auth";
import {
  getFirestore,
  query,
  getDocs,
  collection,
  where,
  addDoc,
} from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyCMXpq8b2upE1yka5MI7Vx9-p-6yaLsj2E",
  authDomain: "kurdishtalent-bfa78.firebaseapp.com",
  projectId: "kurdishtalent-bfa78",
  storageBucket: "kurdishtalent-bfa78.appspot.com",
  messagingSenderId: "48516816480",
  appId: "1:48516816480:web:f2dda9d9917d13b30c6d05"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();
// Ask Google explicitly for email + profile (some accounts / consent flows omit email otherwise).
googleProvider.addScope("email");
googleProvider.addScope("profile");
const twitterProvider = new TwitterAuthProvider();

const appleProvider = new OAuthProvider("apple.com");
appleProvider.addScope("email");
appleProvider.addScope("name");

const resolveUserEmail = (user) => {
  if (!user) return null;
  if (user.email) return user.email;

  const providerEmail = user.providerData?.find((provider) => provider?.email)?.email;
  return providerEmail || null;
};

const resolveUserNameParts = (user) => {
  const fullName = (user?.displayName || "").trim();
  if (!fullName) {
    return { first_name: "", last_name: "" };
  }

  const parts = fullName.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return { first_name: parts[0], last_name: "" };
  }

  return {
    first_name: parts[0],
    last_name: parts.slice(1).join(" "),
  };
};


const signInWithTwitter = async (e) => {
  try {
    const res = await signInWithPopup(auth, twitterProvider);
    const user = res.user;  
    const { first_name, last_name } = resolveUserNameParts(user);
    console.log(user)
    var _userObj = {
      role: "participant",
      uid: user.uid,
      email: resolveUserEmail(user),
      image_path: user.photoURL,
      name: user.displayName,
      first_name,
      last_name,
      authProvider: "twitter",
    };
    return _userObj;
  } catch (err) {
    console.error(err);
    return null; 
  }
};

const signInWithGoogle = async (e) => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;  
    const { first_name, last_name } = resolveUserNameParts(user);
    console.log(user)
    var _userObj = {
      role: "participant",
      uid: user.uid,
      email: resolveUserEmail(user),
      image_path: user.photoURL,
      name: user.displayName,
      first_name,
      last_name,
      authProvider: "google",
    };
    return _userObj;
  } catch (err) {
    console.error(err);
    return {
      errorCode: err?.code || "auth/unknown",
      errorMessage: err?.message || "Unknown authentication error",
    };
  }
};

const signInWithApple = async (e) => {
  try {
    const res = await signInWithPopup(auth, appleProvider);
    const user = res.user;
    const profile = res.additionalUserInfo?.profile || {};
    const token = res._tokenResponse || {};
    const email =
      resolveUserEmail(user) ||
      token.email ||
      profile.email ||
      null;

    let first_name;
    let last_name;
    const appleName = profile.name;
    if (appleName && (appleName.firstName || appleName.lastName)) {
      first_name = appleName.firstName || "";
      last_name = appleName.lastName || "";
    } else {
      ({ first_name, last_name } = resolveUserNameParts(user));
    }
    const name =
      user.displayName ||
      [first_name, last_name].filter(Boolean).join(" ").trim() ||
      null;

    console.log(user)

    var _userObj = {
      role: "participant",
      uid: user.uid,
      email,
      image_path: user.photoURL,
      name,
      first_name,
      last_name,
      authProvider: "apple",
    };
    return _userObj;
  } catch (err) {
    console.error(err);
    return {
      errorCode: err?.code || "auth/unknown",
      errorMessage: err?.message || "Unknown authentication error",
    };
  }
};

const logInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const registerWithEmailAndPassword = async (name, email, password) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};

export {
  app,
  auth,
  db,
  signInWithGoogle,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordReset,
  logout,
  signInWithTwitter,
  signInWithApple,
};